import "./index.css";

// import "font-awesome/css/font-awesome.min.css";
// import "simple-line-icons/css/simple-line-icons.css";
import { createRoot } from "react-dom/client";
import { ErrorBoundary } from "react-error-boundary";
import { BrowserRouter } from "react-router-dom";

import App from "./App.tsx";
import ErrorFallback from "./core/error/ErrorFallback.tsx";

createRoot(document.getElementById("root")!).render(
  // <StrictMode>
  <ErrorBoundary fallbackRender={(props) => <ErrorFallback {...props} />}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </ErrorBoundary>
  // </StrictMode>
);
